import React from 'react';
import { Route, Switch } from 'react-router-dom';

import ClientRouter from '../ClientRouter';
import { loadable } from '../util/routeUtils';
import UserContextRoute from '../components/util/UserContextRoute';

const BrandsLandingContainer = loadable(() => import('../pages/Brands/BrandsLandingContainer'));
const ShopHomeLandingContainer = loadable(
  () => import('../pages/ShopPages/ShopHomeLandingContainer')
);
const CollectionsLandingContainer = loadable(
  () => import('../pages/ShopPages/CollectionsLandingContainer')
);
const ShopSearchLandingContainer = loadable(
  () => import('../pages/ShopPages/ShopSearchLandingContainer')
);
const FeaturedBrandsLandingContainer = loadable(
  () => import('../pages/ShopPages/FeaturedBrandsLandingContainer')
);
const PartnerBoutiqueLandingContainer = loadable(
  () => import('../pages/ShopPages/PartnerBoutiqueLandingContainer')
);
const KitProductDetailPage = loadable(
  () => import('../pages/KitProductDetailPage/KitProductDetailPage')
);
const BackorderCancellation = loadable(() => import('../pages/Order/BackorderCancellation'));
const ReviewListing = loadable(() => import('../pages/RatingsReviews/RatingsReviews'));
const ReviewSubmission = loadable(
  () => import('../pages/RatingsReviewsSubmission/RatingsReviewsSubmission')
);
const ReviewUnsubscription = loadable(
  () => import('../pages/RatingsReviews/components/ReviewUnsubscription/ReviewUnsubscription')
);
const ReviewExist = loadable(
  () => import('../pages/RatingsReviews/components/ReviewExist/ReviewExist')
);
const NoMatch = loadable(() => import('../pages/NoMatch/NoMatch'));

const ShopRoutes = () => (
  <ClientRouter>
    <Switch>
      <Route exact path="/shop/brands/:categoryKey?" component={BrandsLandingContainer} />
      <Route exact path="/shop/index" component={ShopHomeLandingContainer} />
      <Route
        exact
        path="/shop/collection/:collectionKey?"
        component={CollectionsLandingContainer}
      />
      <Route exact path="/shop/brand/:brandKey?" component={FeaturedBrandsLandingContainer} />
      <Route exact path="/search/gifts" component={ShopSearchLandingContainer} />
      <Route
        exact
        path="/shop/partner-boutique/:brandKey?"
        component={PartnerBoutiqueLandingContainer}
      />
      <Route exact path="/shop/kit/:productKey" component={KitProductDetailPage} />
      <Route exact path="/order/cancel" component={BackorderCancellation} />
      <UserContextRoute exact path="/account/settings/reviews" component={ReviewListing} />
      <UserContextRoute
        exact
        path="/account/settings/reviews/submission"
        component={ReviewSubmission}
      />
      <UserContextRoute
        exact
        path="/account/settings/reviews/unsubscribe/:userId"
        component={ReviewUnsubscription}
      />
      <UserContextRoute path="/review-exist" component={ReviewExist} />
      <Route component={NoMatch} />
    </Switch>
  </ClientRouter>
);

export default ShopRoutes;
